/**
 * How the booth screen arranges a category, in D's words and D's order (28 September).
 *
 * A product's section is free text, so a new one needs no release; these are the ones the
 * desk offers and the order the till shows them in. Anything else follows, by name.
 */
export const SHELF_SECTIONS = [
    "Booster Packs",
    "Booster Bundles",
    "Booster Boxes",
    "Elite Trainer Boxes",
    "Collections & Sets",
    "Cases & Displays",
    "Others",
];
/**
 * The names the sections had until 8 October 2026, when D renamed three of them. A sheet
 * or a form that still says the old name means the new one.
 */
const RENAMED = {
    packs: "Booster Packs",
    bundles: "Booster Bundles",
    etbs: "Elite Trainer Boxes",
    etb: "Elite Trainer Boxes",
};
/** A section as the shop now names it: an old name becomes the new one, anything else is kept. */
export function shelfSection(section) {
    return RENAMED[section.replace(/\s+/g, " ").trim().toLowerCase()] ?? section;
}
/** Where a section sits in the row, D's first and the rest after. */
export function sectionRank(section) {
    const at = SHELF_SECTIONS.findIndex((name) => name.toLowerCase() === section.trim().toLowerCase());
    return at === -1 ? SHELF_SECTIONS.length : at;
}
/**
 * The order the categories come in: what a booth sells most first. D asked for Sealed
 * Products ahead of Accessories on the Lorcana shelf; the rest follow by name.
 */
const CATEGORY_ORDER = [/sealed/i, /^singles?$/i, /^slabs?$/i];
export function categoryRank(category) {
    const at = CATEGORY_ORDER.findIndex((pattern) => pattern.test(category.trim()));
    return at === -1 ? CATEGORY_ORDER.length : at;
}
//# sourceMappingURL=shelf.js.map